<template>
    <mdb-col col="12">
        <div class="elfsight-app-76784924-6152-433d-968f-89e6afae1c33"></div>
    </mdb-col>
</template>

<script>
import {mdbCol} from 'mdbvue'
export default {
    components: {
        mdbCol
    }
}
</script>